import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16} from '@homeaway/svg-defs';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import throttle from 'lodash.throttle';
import classNames from 'classnames';

import MobileNav from './MobileNav';
import CategoryAccordion from '../CategoryAccordion/CategoryAccordion';

import {HomeRouteContext} from 'utils/context';

import './Header.less';

export class HeaderComponent extends Component {
    static contextType = HomeRouteContext;
    constructor(props) {
        super(props);

        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            this.attachListeners();
        }

        this.throttledHandler = throttle(this.scrollHandler, 500);

        this.state = {
            scrolled: false,
            currentPath: '',
        };
    }

    componentDidMount() {
        this.attachListeners();
    }

    componentWillUnmount() {
        this.detachListeners();
    }

    attachListeners = () => {
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.throttledHandler);
        }
    };

    detachListeners = () => {
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.throttledHandler);
        }
    };

    onExpandMenu = () => {
        document.body.classList.toggle('nav-menu-open');
    };

    scrollHandler = () => {
        if (window.pageYOffset > 0) {
            this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    };

    render() {
        const {
            systemData,
            translations = {},
            categories = [],
            allCategories = [],
            isMobile,
            location,
            homeRoute,
        } = this.props;
        const {hostname, humanReadableName, siteName} = systemData;
        const homePageUrl = `https://${hostname}`;
        const fixedClasses = classNames('Header--fixed', {
            'Header--shadow': this.state.scrolled,
        });

        const renderedCategoryAccordion = categories.map((category, idx) => {
            const isActive = location.pathname.indexOf(`${category.path}`) > -1;

            return (
                <CategoryAccordion
                    key={idx}
                    isActive={isActive}
                    allCategories={allCategories}
                    level={1}
                    isMobile={isMobile}
                    location={location}
                    {...category}
                    translations={translations}
                />
            );
        });

        let logoUrl;
        try {
            logoUrl = require(`./logos/${siteName}.svg`)();
        } catch (err) {
            logoUrl = `//csvcus.homeaway.com/rsrcs/cdn-logos/4.1.4/sitename/${siteName}/web/logo.svg`;
        }

        return (
            <header className="Header main-wrapper">
                <nav className={fixedClasses}>
                    <div className="Header__logo">
                        <a href={homePageUrl}>
                            <img src={logoUrl} alt={humanReadableName} />
                        </a>
                    </div>

                    {!isMobile && (
                        <ul className="Header__middle-items">
                            <li className="Header__middle-item">
                                <Link
                                    to={homeRoute}
                                    className="Header__home-link"
                                >
                                    {translations.home}
                                </Link>
                            </li>
                            <li className="Header__middle-item">
                                <Dropdown
                                    label={translations.categories}
                                    id="header_dropdown"
                                    dropdownRight
                                    onDropdownShow={this.onExpandMenu}
                                    onDropdownHide={this.onExpandMenu}
                                    customToggle={
                                        <button className="Header__dropdown btn">
                                            {translations.categories}
                                            <SVGIcon
                                                inline
                                                className="Header__dropdown-svg"
                                                markup={CHEVRON_DOWN__16}
                                            />
                                        </button>
                                    }
                                >
                                    {renderedCategoryAccordion}
                                </Dropdown>
                            </li>
                            <li className="Header__button hidden-xs hidden-sm">
                                <a
                                    className="btn btn-default"
                                    href={homePageUrl}
                                >
                                    {translations.headerButton}
                                </a>
                            </li>
                        </ul>
                    )}
                    {isMobile && (
                        <MobileNav
                            translations={translations}
                            homeRoute={homeRoute}
                        >
                            {renderedCategoryAccordion}
                        </MobileNav>
                    )}
                </nav>
            </header>
        );
    }
}

export const Header = determineIfMobile(HeaderComponent);
